"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useRef, useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
export default function ContactHero() {
  const {
    ref: cardRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const [parallaxOffset, setParallaxOffset] = useState(0);
  const sectionRef = useRef<HTMLElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (sectionRef.current) {
        const rect = sectionRef.current.getBoundingClientRect();
        const scrolled = window.scrollY;
        const offset = scrolled * 0.02;
        setParallaxOffset(offset);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section ref={sectionRef} className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center transition-transform duration-700 ease-out hover:scale-[1.01] bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1475438/img/contact_hero_background.png)]" style={{
      transform: `translateY(${parallaxOffset}px)`
    }} />

      {}
      <div className="absolute inset-0 bg-black/50" />

      {}
      <div ref={cardRef} className={`relative z-10 w-full max-w-3xl mx-auto px-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <Card className="glass-effect shadow-strong">
          <CardContent className="text-center space-y-4 py-12 px-8">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold text-foreground">Get in Touch with Us</h1>
            <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto">
              Let's discuss how we can accelerate your product innovation with cutting-edge materials and expert consulting.
            </p>
          </CardContent>
        </Card>
      </div>
    </section>;
}